import { useCallback, useEffect, useMemo, useState } from 'react'
import { ConvertLocalTimeGet, GetDurationMinutes, GetDurationDays } from '../../utils'
import { Images } from '../../assets'

import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import {
  LowerTable,
  UpperTable,
  SortButton,
  IconWrapper,
  UpperTableRow,
  LowerTableRow,
  UpperTableData,
  UpperTableHead,
  ExclamationIcon,
  ContainerActivity,
  FirstChildCellArranger,
  ColorStatus,
} from './service-request-detail.styled'
import Popover from './popover/popover.components'


const Activity = ({ dataSr }) => {
  const [activity, setActivity] = useState([])
  const [anchorEl, setAnchorEl] = useState(null)
  const [selectedTask, setSelectedTask] = useState()
  const [sortOrder, setSortOrder] = useState('asc')

  const open = Boolean(anchorEl)

  const headerStyle = {
    background: '#F5F5F5',
    color: '#777777',
  }

  const getStatusColor = (task) => {
    if (task.is_red) return '#E82D2D'
    if (task.is_green) return '#95C123'
    if (task.is_orange) return '#FFB000'
    return '#777777'
  }

  const isChecklist = useMemo(() =>
    dataSr.Activity_Type === 'Checklist'
    , [dataSr.Activity_Type])

  const initialColumns = [
    { label: '#', width: '50px' },
    { label: 'Task', width: '200px' },
    { label: 'Planning Start', width: '160px' },
    { label: 'Planning Finish', width: '160px' },
    { label: 'Planning Duration in Hours', width: '200px' },
    { label: 'Planning Duration in Days', width: '200px' },
    { label: 'Actual Start', width: '160px' },
    { label: 'Actual Finish', width: '160px' },
    { label: 'Actual Duration in Hours', width: '180px' },
    { label: 'Actual Duration in Days', width: '180px' },
  ]

  const [columns, setColumns] = useState(initialColumns)

  const updateColumnsForChecklist = useCallback(() => {
    if (isChecklist) {
      return [
        { label: 'No', width: '50px' },
        ...initialColumns.slice(1, 2),
        { label: 'PIC', width: '160px' },
        { label: 'Level', width: '160px' },
        { label: 'Status', width: '160px' },
        ...initialColumns.slice(2),
        { label: 'action', width: '50px' },
      ]
    }
    return initialColumns
  }, [isChecklist])

  const handleSort = (e, key) => {
    const sortedDetails = [...e.Details].sort((a, b) => {
      if (sortOrder === 'asc') {
        return a[key] > b[key] ? 1 : -1
      } else {
        return a[key] < b[key] ? 1 : -1
      }
    })
    e.Details = sortedDetails // Update the array
    setSortOrder(sortOrder === 'asc' ? 'desc' : 'asc') // Toggle sort order
  }

  const handlePopoverOpen = (task) => (event) => {
    setAnchorEl(event.currentTarget)
    setSelectedTask(task)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  useEffect(() => {
    setColumns(updateColumnsForChecklist())
  }, [dataSr, updateColumnsForChecklist])

  useEffect(() => {
    let newActivity = dataSr.Activity?.map(e => {
      return {
        ...e,
        isOpen: true
      }
    })
    setActivity(newActivity)
  }, [dataSr])

  const openChild = (ID) => {
    let openActivity = activity.map(e => {
      return {
        ...e,
        isOpen: e.ID === ID ? !e.isOpen : e.isOpen
      }
    })
    setActivity(openActivity)
  }

  return (
    <ContainerActivity>
      <UpperTable>
        <thead>
          <tr>
            <UpperTableHead>List Activity</UpperTableHead>
          </tr>
        </thead>
      </UpperTable>
      <tbody >
        {activity && activity.map((e, i) => {
          let color = '#777777'
          if (e.Details?.some(detail => detail.is_red)) {
            color = '#E82D2D'
          } else if (e.Details?.some(detail => detail.is_orange)) {
            color = '#FFB000'
          } else if (e.Details?.every(detail => detail.is_green)) {
            color = '#95C123'
          }
          return (<>
            <UpperTableRow>
              <UpperTableData onClick={() => { openChild(e.ID) }}>
                <FirstChildCellArranger>
                  <div style={{ paddingTop: '10px' }}>
                    <ExpandMoreIcon />
                  </div>
                  <div>
                    {e.Activity_Name} ({e.Details ? e.Details.length : 0})
                  </div>
                  {isChecklist && (
                    <ColorStatus size='small' style={{ backgroundColor: color }} />
                  )}
                </FirstChildCellArranger>
              </UpperTableData>
            </UpperTableRow>
            {e.isOpen && e.Details && e.Details.length !== 0 &&
              <tr style={{ background: '#F5F5F5' }}>
                <LowerTable>
                  <thead>
                    <LowerTableRow>
                      {columns.map((col, index) => (
                        <th key={index} style={{ ...headerStyle, width: col.width }}>
                          {col.label === 'action' ? (
                            <SortButton onClick={() => handleSort(e, 'label')}>
                              <img src={Images.SortIcon} alt='Sort' />
                              Sort
                            </SortButton>
                          ) : (
                            col.label
                          )}
                        </th>
                      ))}
                    </LowerTableRow>
                  </thead>
                  <tbody>
                    {e.isOpen && e.Details?.map((child, index) => {
                      let planStart = ConvertLocalTimeGet(dataSr.Location, child.plan_start_time, 'DD/MM/YYYY HH:mm')
                      let planFinish = ConvertLocalTimeGet(dataSr.Location, child.plan_finish_time, 'DD/MM/YYYY HH:mm')
                      let actualStart = ConvertLocalTimeGet(dataSr.Location, child.actual_start_time, 'DD/MM/YYYY HH:mm')
                      let actualFinish = ConvertLocalTimeGet(dataSr.Location, child.actual_finish_time, 'DD/MM/YYYY HH:mm')
                      const showPopoverIcon = child.requirement || child.compliance_parameter

                      return (
                        <>
                          <LowerTableRow>
                            <td>{isChecklist ? index + 1 : `${i + 1}.${child.sort_no}`}</td>
                            <td>
                              {isChecklist ? (
                                <FirstChildCellArranger>
                                  <span>{child.task || '-'}</span>
                                  {showPopoverIcon && (
                                    <IconWrapper>
                                      <ExclamationIcon src={Images.ExclamationIcon} onClick={handlePopoverOpen(child)} />
                                    </IconWrapper>
                                  )}
                                  <Popover
                                    open={open}
                                    anchorEl={anchorEl}
                                    task={selectedTask}
                                    handlePopoverClose={handlePopoverClose}
                                  />
                                </FirstChildCellArranger>
                              ) : (
                                <span>{child.task || '-'}</span>
                              )}
                            </td>
                            {isChecklist && <td>{child.pic || '-'}</td>}
                            {isChecklist && <td>{child.level_value || '-'}</td>}
                            {isChecklist && (<td>
                              <ColorStatus size='small' style={{ backgroundColor: getStatusColor(child) }} />
                            </td>)}
                            <td>{planStart || '-'}</td>
                            <td>{planFinish || '-'}</td>
                            <td>{
                              planStart && planStart.length > 0
                                && planFinish && planFinish.length > 0
                                ? GetDurationMinutes(child.plan_start_time, child.plan_finish_time, 0)
                                : '0 Hours 0 Minutes'}</td>
                            <td>{
                              planStart && planStart.length > 0
                                && planFinish && planFinish.length > 0
                                ? GetDurationDays(child.plan_start_time, child.plan_finish_time, 0)
                                : '0 Days'}</td>
                            <td>{actualStart || '-'}</td>
                            <td>{actualFinish || '-'}</td>
                            <td>{
                              actualStart && actualStart.length > 0
                                && actualFinish && actualFinish.length > 0
                                ? GetDurationMinutes(child.actual_start_time, child.actual_finish_time, 0)
                                : '0 Hours 0 Minutes'}</td>
                            <td>{
                              actualStart && actualStart.length > 0
                                && actualFinish && actualFinish.length > 0
                                ? GetDurationDays(child.actual_start_time, child.actual_finish_time, 0)
                                : '0 Days'}</td>
                          </LowerTableRow>
                        </>
                      )
                    })}
                  </tbody>
                </LowerTable>
              </tr>
            }
          </>)
        })}
      </tbody>
    </ContainerActivity>
  )
}

export default Activity

